import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable()
export class UnauthorizedRequestInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            //this shouldn't happen due to access token expiration, auth0 will cache the token and silently refresh it when it's near expiration.
            //so, when it doubt, log it
            console.error(`rx 401 from ${request.url}`)
          }
        } else {
          console.error(
            `Login Required. Reload your page to prevent undesired behavior.`,
          )
        }
        return throwError(error)
      }),
    )
  }
}
